import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ContextService } from 'src/core/services/context.service';
import { FormatService } from 'src/core/services/format.service';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { ProductFormView } from '../product-form.view';
import { ProductCategoryListDataService } from '../../../product-categories/list/product-category-list.data';
import { ToastNotifications } from 'src/core/ui/toast';
import { ConfigurationService } from 'src/core/services/configuration.service';

interface ProductChildControllerProps extends ComponentViewProps<ProductItem> {
	mode: ControlMode;
	contextService: ContextService;
	formatService: FormatService
	parentProduct: ProductItem;
	toast: ToastNotifications;
	defaultLanguage: string;
	identityService: any;
	schema: JsonSchema;
}

interface State {
	allotmentNew?: AllotmentItem,
}

@observer
export class ProductChildController extends React.Component<ProductChildControllerProps, State> {

	protected categoryDataService: ProductCategoryListDataService;

	@resolve
	protected dialogService: DialogService;

	@resolve
	protected configurationService: ConfigurationService;

	@observable
	productCodeRequired: boolean;

	constructor(props: Readonly<ProductChildControllerProps>) {
		super(props);

		this.state = {};
	}

	componentDidMount() {
		this.configurationService.current()
			.then(res => {
				this.productCodeRequired = res.productCodeRequired;
			});

		this.categoryDataService = ProductCategoryListDataService.make(this.props.contextService);
		if (this.props.model != null) {
			if (this.props.model.dynamicProperties['erratas'] == null) {
				this.props.model.dynamicProperties['erratas'] = [];
			}
			this.categoryDataService.addFilter('productType', 'eq', this.props.model.productType);
			this.categoryDataService.addSorting('id', 'asc', true);
			this.categoryDataService.load(query => query);
		}
	}

	render() {
		if (this.props.model == null) {
			return null;
		}

		return (
			<ProductFormView
				identityService={this.props.identityService}
				defaultLanguage={this.props.defaultLanguage}
				toast={this.props.toast}
				mode={this.props.mode}
				model={this.props.model}
				contextService={this.props.contextService}
				formatService={this.props.formatService}
				setBusy={this.props.setBusy}
				productCodeRequired={this.productCodeRequired}
				schema={this.props.schema}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/products/form/parts/product-child.controller.tsx